<template>
  <div>
    <template v-for="(item, $index) in ruleAnswerList">
      <div class="panel-box" :key="$index + '_1'">
        <ProjRuleAnswerViewListTypeItem ref="ruleEditListTypeItem" :ruleTypeItem="item" :ruleTypeItemIndex="$index" />
      </div>
      <div class="eb-line" :key="$index + '_2'"></div>
    </template>
  </div>
</template>
<script>
import ProjRuleAnswerViewListTypeItem from './ProjRuleAnswerViewListTypeItem';

export default {
  name: 'ProjRuleAnswerViewList',
  components: {
    ProjRuleAnswerViewListTypeItem
  },
  filters: {},
  props: {
    ruleAnswerList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
</style>
